module.exports = __webpack_public_path__ + "static/media/emissor-r-3.3bc9f583.png";